import type { ReactNode } from "react";

/**
 * The one bordered, rounded block a list of issues sits in, with a hairline
 * between rows, rather than separate cards. `divide-y` keeps the rule off the
 * outer edges, so only the container's own corners round — no per-row radius to
 * keep in sync.
 *
 * `overflow-clip` rather than `overflow-hidden`: it rounds the corners the same
 * way without becoming a scroll container, so the table header can still stick
 * to the top of the scrolling area. See [[issue-list-frame.spec]].
 */
export function IssueListFrame({ children }: { children: ReactNode }) {
  return (
    <div className="divide-y divide-border overflow-clip rounded-[10px] border border-border bg-card">
      {children}
    </div>
  );
}
